import { useLocales } from 'src/locales';

const englishMessage = {
  shortMessage:
    'Scheduled maintenance: July 13, 2025 1:00 AM - July 13, 2025 6:00 AM (Brazil time)',
  modalTitle: 'Scheduled System Maintenance',
  modalMessage:
    'We have scheduled a maintenance window from July 13, 2025 at 1:00 AM to July 13, 2025 at 6:00 AM (Brazil time). This maintenance is aimed at improving our multi-regional infrastructure to enhance service quality for our customers located in Brazil and the United States. During this maintenance period, the system may be temporarily unavailable. We apologize for any inconvenience and appreciate your understanding as we work to improve your experience.',
};

const portugueseMessage = {
  shortMessage:
    'Manutenção agendada: 13 de julho de 2025 01:00 - 13 de julho de 2025 06:00 (Horário do Brasil)',
  modalTitle: 'Manutenção Agendada',
  modalMessage:
    'Temos agendada uma janela de manutenção da 01:00 de 13 de julho de 2025 até 06:00 de 13 de julho de 2025 (Horário do Brasil). Esta manutenção tem como objetivo melhorar nossa infraestrutura multi-regional para melhorar a qualidade do serviço para nossos clientes localizados no Brasil e nos Estados Unidos. Durante este período de manutenção, o sistema pode estar temporariamente indisponível. Pedimos desculpas pelo inconveniente e agradecemos a compreensão enquanto trabalhamos para melhorar sua experiência.',
};

export function useGlobalALertQuery() {
  const { currentLang } = useLocales();

  const showAlert = false;
  const shortMessage =
    currentLang.value === 'en'
      ? englishMessage.shortMessage
      : portugueseMessage.shortMessage;
  const showMoreModal = true;
  const modalTitle =
    currentLang.value === 'en'
      ? englishMessage.modalTitle
      : portugueseMessage.modalTitle;
  const modalMessage =
    currentLang.value === 'en'
      ? englishMessage.modalMessage
      : portugueseMessage.modalMessage;

  return {
    showAlert,
    shortMessage,
    showMoreModal,
    modalTitle,
    modalMessage,
  };
}
